/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { DocumentDetailsRequestDTO } from './DocumentDetailsRequestDTO';

export type BusinessDetailsNigeriaDTO = {
    businessDescription?: string;
    businessSector?: string;
    businessTradingName?: string;
    businessType?: string;
    documents?: Array<DocumentDetailsRequestDTO>;
    mccCode?: string;
    /**
     * Ignored: the SCUML requirement is worked out from the sub-category, or from a sector without any.
     */
    requireScuml?: boolean;
    sectorId?: string;
    /**
     * One of the sub-categories of the sector. Required when the sector has sub-categories; when left out, the merchant's saved sub-category is used.
     */
    subCategoryId?: number;
    verificationStatus?: BusinessDetailsNigeriaDTO.verificationStatus;
};

export namespace BusinessDetailsNigeriaDTO {

    export enum verificationStatus {
        PENDING = 'PENDING',
        SUCCESS = 'SUCCESS',
        FAILED = 'FAILED',
    }


}

